import React from "react";
import IconInnpoland from "../../../../assets/img/innpoland/dociekliwosc_dziennikarska_inn.svg"

import AttachmentContentBase from "../../../../redesign/components/AttachmentBase";
import { AttachmentElement } from "../../../../components/Article/Parts/Slate/types"


type AttachmentProps = {
    element: AttachmentElement;
};

const AttachmentContent: React.FC<AttachmentProps> = ({
    element,
}) => {

    return (
        <AttachmentContentBase element={element} icon={IconInnpoland} />
    );
};

export default AttachmentContent;
